import Images_Icons from "./icons-images"
import DiscordLogo from '../assets/Discord.png'


export const footerIcons = [
    {
        id: "1",
        icon: Images_Icons.DiscordLogo,
        link: "",
    },
    {
        id: "2",
        icon: Images_Icons.TwitterLogo,
        link: "",
    },
    {
        id: "3",
        icon: Images_Icons.GithubLogo,
        link: "",
    }

]


export const footerLinks = [
    {
        id: "1",
        links: [
          "test",
          "testings",
          "testings",
          "testings",
          "testings",
          "testing",
          "testing",
          "testing",
        ],
      },
      {
        id: "2",
        links: ["Pages", "Home", "Dashboard", "Protocols", "Claims"],
      },
]